import api from "../utils/api-axios";

export const messageApi = {
  getUsers: async () => {
    return api.get("/messages/user");
  },

  getMessages: async (userId) => {
    return api.get(`/messages/${userId}`);
  },

  // NEW: Check for existing conversation without creating one
  getExistingMessages: async (userId) => {
    return api.get(`/messages/check/${userId}`);
  },

  sendMessage: async (messageData) => {
    return api.post(`/messages/send/${messageData.receiverId}`, {
      text: messageData.content,
    });
  },

  markMessagesSeen: async (userId) => {
    return api.put(`/messages/mark/${userId}`);
  },

  // Flag a specific message
  flagMessage: async (messageId, reason) => {
    return api.put(`/messages/flag/${messageId}`, { reason });
  },

  // Report/flag a conversation
  reportConversation: async (conversationId, reason) => {
    return api.put(`/messages/report/${conversationId}`, { reason });
  },

  // Get flagged conversations (admin)
  getFlaggedConversations: async () => {
    return api.get("/messages/admin/flagged");
  },
};